// extracted by mini-css-extract-plugin
export default {"events":"UpcomingEvents_events__0Dk-2"};